import Service from '../Service'
import {http} from '../config'

export default class BeneficiarioOcorrenciaService extends Service{
    constructor(){
        super('BeneficiarioOcorrencia');
    }

    BuscarBeneficiario(q){
        return http.get(`${this.getNomeControle()}/BuscarBeneficiario`, {
            params: { q }
        });
    }

    ResumoBeneficiario(beneficiarioId){
        return http.get(`${this.getNomeControle()}/ResumoBeneficiario`, {
            params: { beneficiarioId }
        });
    }

    Historico(ocorrenciaId){
        return http.get(`${this.getNomeControle()}/${ocorrenciaId}/Historico`);
    }

    ListarOcorrencias(filter){
        const filtros = [];

        if(filter.beneficiarioId)
            filtros.push(`beneficiarioId eq ${filter.beneficiarioId}`);

        if(filter.dataInicial)
            filtros.push(`dataOcorrencia ge ${filter.dataInicial}`);

        if(filter.dataFinal)
            filtros.push(`dataOcorrencia le ${filter.dataFinal}`);

        if(filter.ocorrenciaTipoId)
            filtros.push(`ocorrenciaTipoId eq ${filter.ocorrenciaTipoId}`);

        if(filter.gravidade)
            filtros.push(`gravidade eq '${filter.gravidade}'`);

        if(filter.projetoId)
            filtros.push(`projetoId eq ${filter.projetoId}`);

        let parametros = '?$top=100&$orderby=dataOcorrencia desc,id desc';

        if(filtros.length > 0)
            parametros += `&$filter=${filtros.join(' and ')}`;

        return http.get(`${this.getNomeControle()}${parametros}`, this.GetHeader('Beneficiario,Projeto,OcorrenciaTipo,Usuario'));
    }

    Relatorio(filter){
        return http.get(`${this.getNomeControle()}/Relatorio`, {
            params: filter
        });
    }

    EnviarDocumento(ocorrenciaId, nome, arquivo){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', new Blob([arquivo]));

        return http.post(`${this.getNomeControle()}/${ocorrenciaId}/documento`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' },
            params: { nome }
        });
    }

    DeletarDocumento(ocorrenciaId, nome){
        return http.delete(`${this.getNomeControle()}/${ocorrenciaId}/documento`, {
            params: { nome }
        });
    }

    DownloadDocumento(ocorrenciaId, nome){
        return http.get(`${this.getNomeControle()}/${ocorrenciaId}/documento`, {
            responseType: 'blob',
            params: { nome }
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nome);
            document.body.appendChild(link);
            link.click();
        });
    }
}
